import FeatureNotAvailable from "./FeatureNotAvailable";

export default FeatureNotAvailable;
